import { render, staticRenderFns } from "./WarehouseClassDetail.vue?vue&type=template&id=63b149bd&scoped=true"
import script from "./WarehouseClassDetail.vue?vue&type=script&lang=js"
export * from "./WarehouseClassDetail.vue?vue&type=script&lang=js"
import style0 from "./WarehouseClassDetail.vue?vue&type=style&index=0&id=63b149bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b149bd",
  null
  
)

export default component.exports